module.exports = __webpack_public_path__ + "img/crust-maxwell.d9114741.svg";